import compose from 'lodash/fp/compose';
import { firestoreAction } from 'vuexfire';

import { canAdd, canUpdate } from '../plugins';
import topicsApi from '../../firebase/topics';
import { db } from '../../firebase';
import PluggableModule from '../pluggable';

const topics = new PluggableModule('topic');

topics.addMutationTypes([
  'TOPICS_GET_INIT',
  'TOPICS_GET_DONE',
  'TOPICS_GET_ERROR',
  'TOPIC_GET_INIT',
  'TOPIC_GET_ERROR',
  'TOPIC_GET_DONE'
]);

topics.extend({
  namespaced: true,
  state: {
    list: [],
    selected: {},
    loading: false,
    binded: false,
    error: null,
    // Concepts in selected topic
    concepts: [],
    loadingTopic: false,
    errorTopic: false,
    submitting: false
  },
  mutations: {
    [topics.con.TOPICS_GET_INIT](state) {
      state.loading = true;
    },
    [topics.con.TOPICS_GET_DONE](state) {
      state.loading = false;
      state.binded = true;
    },
    [topics.con.TOPICS_GET_ERROR](state, error) {
      state.loading = false;
      state.error = error;
    },
    [topics.con.TOPIC_GET_INIT](state) {
      state.loadingTopic = true;
      state.errorTopic = null;
    },
    [topics.con.TOPIC_GET_DONE](state, data) {
      state.loadingTopic = false;
      state.selected = data;
    },
    [topics.con.TOPIC_GET_ERROR](state, error) {
      state.loadingTopic = false;
      state.errorTopic = error;
    }
  },
  actions: {
    async addTopic({ commit }, data) {
      commit(topics.con.TOPIC_SUBMIT_INIT);
      try {
        const newTopicRef = await topicsApi.add(data);
        commit(topics.con.TOPIC_CREATED, newTopicRef.id);
        commit(topics.con.TOPIC_SUBMIT_DONE);
      } catch (error) {
        commit(topics.con.TOPIC_SUBMIT_DONE);
        throw error;
      }
    },
    async getTopic({ commit, dispatch }, id) {
      commit(topics.con.LOADING_INIT, null, { root: true });
      commit(topics.con.TOPIC_GET_INIT);
      try {
        const data = await topicsApi.get(id);
        await dispatch('setConceptsRef', id);
        commit(topics.con.TOPIC_GET_DONE, data);
      } catch (error) {
        commit(topics.con.TOPIC_GET_ERROR, error);
      }
      commit(topics.con.LOADING_DONE, null, { root: true });
    },
    async getTopics({ commit, dispatch, state }) {
      if (state.binded) return;

      commit(topics.con.LOADING_INIT, null, { root: true });
      commit(topics.con.TOPICS_GET_INIT);
      try {
        await dispatch('setTopicsRef');
        commit(topics.con.TOPICS_GET_DONE);
      } catch (error) {
        commit(topics.con.TOPICS_GET_ERROR, error);
      }
      commit(topics.con.LOADING_DONE, null, { root: true });
    },
    // `id` below is id of the topic
    setConceptsRef: firestoreAction(async ({ bindFirestoreRef }, id) => {
      const topicRef = db.collection('topics').doc(id);
      const query = db.collection('concepts').where('topicId', '==', topicRef);
      await bindFirestoreRef('concepts', query, { maxRefDepth: 0 });
    }),
    setTopicsRef: firestoreAction(async ({ bindFirestoreRef }) => {
      await bindFirestoreRef('list', db.collection('topics'), {
        maxRefDepth: 1
      });
    }),
    async updateTopic({ commit }, data) {
      commit(topics.con.TOPIC_SUBMIT_INIT);
      try {
        await topicsApi.update(data);
        commit(topics.con.TOPIC_SUBMIT_DONE);
      } catch (error) {
        commit(topics.con.TOPIC_SUBMIT_DONE);
        throw error;
      }
    },
    async moveConcept({ commit }, data) {
      commit(topics.con.TOPIC_SUBMIT_INIT);
      try {
        await topicsApi.moveConcept(data.topicId, data.from, data.to);
        commit(topics.con.TOPIC_SUBMIT_DONE);
      } catch (error) {
        commit(topics.con.TOPIC_SUBMIT_DONE);
        throw error;
      }
    },
    async moveTopic({ commit }, data) {
      commit(topics.con.LOADING_INIT, null, { root: true });
      commit(topics.con.TOPIC_SUBMIT_INIT);
      try {
        const from = data.fromItem.serialNumber;
        const to = data.toItem.serialNumber;
        await topicsApi.move(from, to);
        commit(topics.con.TOPIC_SUBMIT_DONE);
        commit(topics.con.LOADING_DONE, null, { root: true });
      } catch (error) {
        commit(topics.con.TOPIC_SUBMIT_DONE);
        commit(topics.con.LOADING_DONE, null, { root: true });
        throw error;
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate()
);

export default hop(topics);
